/* eslint-disable react-hooks/exhaustive-deps */

import Layout from '@layout/FreeLayout/FreeLayout';
import Header from '@layout/HeaderTemplates/Base';
import PostPaymentLearnerDetails from '@cont/OfflineCentres/PostPaymentLearnerDetails/PostPaymentLearnerDetails';
import useOfflineCentresStore from '@stores/offline-centres';
import { useEffect } from 'react';
import { modifyData } from '@cont/OfflineCentres/PostPaymentLearnerDetails/utils';
import useMyInfo from '@api/hooks/auth/useMyInfo';
import { getFullName, getMePhone, getIsLoggedIn } from '@api/selectors/auth';
import useFormDetails from '@api/hooks/offlineCentres/useFormDetails';
import CircularLoader from '@base/CircularLoader/CircularLoader';
import styled from '@emotion/styled';

export const Wrapper = styled.div`
  background: linear-gradient(
    180deg,
    var(--color-i-blue-11) 0%,
    var(--color-i-white) 100%
  );
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
`;

const PostPaymentForm = () => {
  const { formDetails, isValidating } = useFormDetails(1);
  const { setPostPaymentFormState } = useOfflineCentresStore();
  const userFullName = useMyInfo(getFullName);
  const phoneNum = useMyInfo(getMePhone);
  const { formData, isFormSubmitted } = formDetails || {};
  if (formData) formData.isFormSubmitted = isFormSubmitted;
  const modifiedData = modifyData(formData);

  const isUserDataLoaded = useMyInfo(getIsLoggedIn);
  const { isLoading: isUserDataLoading, isValidating: userDataNeedsLoading } =
    useMyInfo();

  const isUserLoggedIn = !isUserDataLoading && isUserDataLoaded;
  const isUserLoggedOut = !userDataNeedsLoading && !isUserDataLoaded;

  useEffect(() => {
    setPostPaymentFormState({
      rollNumber: formDetails?.rollNumber,
      ...modifiedData,
      fullName: userFullName,
      phoneNum
    });
  }, [formDetails]);

  return (
    <Wrapper>
      <Header />
      {(isUserLoggedIn || isUserLoggedOut) && !isValidating ? (
        <PostPaymentLearnerDetails data={formDetails} />
      ) : (
        <CircularLoader />
      )}
    </Wrapper>
  );
};

PostPaymentForm.pageInfo = {
  layoutOptions: {
    disableDarkMode: true,
    hideHeader: true,
    hideNudges: true,
    hideGoalSelector: true
  },
  isMWebSupported: true
};

export default PostPaymentForm;

PostPaymentForm.Layout = Layout;
PostPaymentForm.Layout.displayName = 'UNSAT';
PostPaymentForm.Wrapper = null;
